"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.latest = void 0;
var react_1 = __importDefault(require("react"));
var env_1 = require("../../env");
exports.latest = {
  id: 'latest',
  label: 'Latest Activity',
  path: '/latest',
  icon: function (_a) {
    var icons = _a.icons;
    return icons.Feed;
  },
  type: 'feed',
  scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:latest-activity'] : null,
  children: [{
    id: '',
    type: 'feed',
    entities: ['Organisation', 'Person', 'FeedEntry', 'Location', 'ImpactStory'],
    component: function () {
      return react_1.default.createElement(react_1.default.Fragment, null);
    }
  }]
};